import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService } from "./api.service";
import { environment } from 'src/environments/environment';
import { AppConfigService } from 'src/app/app.config.service';

@Injectable({
    providedIn: 'root'
  })

export class PublicService  extends ApiService {

    constructor(private httpClient: HttpClient) {
        super(httpClient);
    
    }
    public getFortalezas() {
      return this.httpClient.get<any[]>(AppConfigService.config.filesUrl +'fortalezas.json');
    }
    
    public getContactData() {
      return this.httpClient.get<any[]>(AppConfigService.config.filesUrl +'contact.json?'+ new Date().getTime());
    }

    public getMainData() {
      return this.httpClient.get<any[]>(AppConfigService.config.filesUrl +'datos.json?'+ new Date().getTime());
    }
    
    public getAboutData() {
      return this.httpClient.get<any[]>(AppConfigService.config.filesUrl +'aboutus.json?'+ new Date().getTime());
    }

    public getFaqData() {
        return this.httpClient.get<any[]>(AppConfigService.config.filesUrl +'faq.json?'+ new Date().getTime());
    }

    public getMenuData() {
      return this.httpClient.get<any[]>(AppConfigService.config.filesUrl +'menu.json?'+ new Date().getTime());
    }

}    